import React, { cloneElement, ReactElement } from 'react';
import { useTranslation } from '../../utils/useTranslation';
import { IconArrowLeft } from '../icon/IconArrowLeft';
import { IconClock } from '../icon/IconClock';
import { IconFillClose } from '../icon/IconFillClose';
import { Flex } from '../layout/Flex';
import { Avatar } from '../media/Avatar';
import { Toolbar } from '../surface/Toolbar';
import { Typography } from '../typography/Typography';
import { CollectionStatus, CollectionUI } from '../users/types';

const getStatus = (collectionModel: CollectionUI) => {
    const t = useTranslation();

    if (!collectionModel.status || collectionModel.status === CollectionStatus.PUBLISHED) {
        return (
            <Typography variant="caption">
                {collectionModel.isPublic ? t('Публичная коллекция') : t('Непубличная коллекция')}
            </Typography>
        );
    }

    if (collectionModel.status === CollectionStatus.MODERATION) {
        return (
            <Flex direction="row" alignItems="center" spacing={0.5}>
                <IconClock size={14} color="var(--color-primary)" />
                <Typography variant="caption">{t('На модерации')}</Typography>
            </Flex>
        );
    }

    if (collectionModel.status === CollectionStatus.DECLINED) {
        return (
            <Flex direction="row" alignItems="center" spacing={0.5}>
                <IconFillClose size={14} color="var(--color-primary)" />
                <Typography variant="caption">{t('Отклонена')}</Typography>
            </Flex>
        );
    }
};

interface HeaderProps {
    collectionModel: CollectionUI;
    onBack: VoidFunction;
    menuSlot: ReactElement;
}

export const Header = (props: HeaderProps) => {
    const { collectionModel, onBack, menuSlot } = props;

    return (
        <Toolbar position="sticky" width="100%" mt={{ sm: -2 }}>
            <Flex
                width="100%"
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                p={2}
            >
                <IconArrowLeft fill="var(--color-primary)" size={24} onClick={onBack} />
                {collectionModel.modifiable ? (
                    <Flex alignItems="center">
                        <Typography as="h1" variant="body" weight="bold">
                            {collectionModel.displayName}
                        </Typography>
                        {!collectionModel.defaultCollection && getStatus(collectionModel)}
                    </Flex>
                ) : (
                    <Flex direction="row" spacing={1.5}>
                        {!collectionModel.defaultCollection && (
                            <Avatar
                                src={collectionModel.author?.avatarUrl[0].url}
                                title={collectionModel.author?.displayName}
                                size={32}
                                border="2px solid var(--color-primary)"
                            />
                        )}
                        <Flex>
                            {!collectionModel.defaultCollection && (
                                <Typography variant="caption">
                                    {collectionModel.author?.displayName}
                                </Typography>
                            )}
                            <Typography variant="body" weight="bold">
                                {collectionModel.displayName}
                            </Typography>
                        </Flex>
                    </Flex>
                )}
                {collectionModel.defaultCollection ? (
                    <Flex width="24px"></Flex>
                ) : (
                    cloneElement(menuSlot)
                )}
            </Flex>
        </Toolbar>
    );
};
